export default __webpack_public_path__ + "static/media/dashboard-gold.ffea88fd.svg";